/* Anyfont 2 Icon */
import React from 'react';
import { colors } from 'ui_system/compass/utils';

export const Remove2 = (props) => {
  const { fill = colors.primary } = props;
  return (
    <svg
      height="512px"
      role="img"
      version="1.1"
      viewBox="0 0 512 512"
      width="512px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>remove</title>
      <g transform="scale(1,-1) translate(0, -512)">
        <path
          d="M257 23c-129 0-234 105-234 232 0 128 105 234 234 234 129 0 232-105 232-232 0-128-105-234-232-234z m0 440c-114 0-208-94-208-208 0-114 94-207 208-207 114 0 206 93 206 207 0 114-92 208-206 208z m-120-307l220 219 18-18-219-220z m0 200l19 18 219-219-18-19z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
